// enum values shortened for efficient storage and retrieval from the database
// or for faster comparison in the code

export enum ENDORSEMENT_STATUS {
  REQUEST_SAVED = '0',
  REQUESTED = '1',
  RE_REQUESTED = '2',
  RESOLVED = '3',
  REJECTED = '4',
  CANCELED = '5',
  INVOICE_RECEIVED = '6',
  INVOICE_ACCEPTED = '7',
  AWAITING_PAYMENT = '8',
  PENDING_APPROVAL_FOR_RATES = '9',
}

export enum ENDORSEMENT_CATEGORY {
  FINANCIAL = '1',
  NON_FINANCIAL = '2',
}

export enum UPDATE_TYPE {
  RE_REQUEST = '1',
  ADDITIONAL_DOCUMENTS = '2',
  INVOICE = '3',
  DECISION = '4',
  ACCEPT_INVOICE = '5',
  SUBMIT_INVOICE = '6',
}

export enum ENDORSEMENT_DECISION {
  RESOLVED = '1',
  REJECTED = '2',
  CANCELED = '3',
}

export const FINANCIAL_STATUS = [
  ENDORSEMENT_STATUS.INVOICE_RECEIVED,
  ENDORSEMENT_STATUS.INVOICE_ACCEPTED,
  ENDORSEMENT_STATUS.AWAITING_PAYMENT,
];

export const POST_INVOICE_RECEIVED_FLOW_STATUSES = [
  ENDORSEMENT_STATUS.INVOICE_ACCEPTED,
  ENDORSEMENT_STATUS.AWAITING_PAYMENT,
  ENDORSEMENT_STATUS.RESOLVED,
];

export const POST_INVOICE_ACCEPTED_FLOW_STATUSES = [
  ENDORSEMENT_STATUS.AWAITING_PAYMENT,
  ENDORSEMENT_STATUS.RESOLVED,
];

export enum ENDORSEMENT_EMAIL_TYPES {
  REQUEST = 1,
  RE_REQUEST,
  ADDITIONAL_DOCUMENTS,
  CANCELLATION,
  INVOICE,
  INVOICE_ACCEPTANCE,
  RESOLVED,
  REJECTED,
}

export const ENDORSEMENT_REFERENCE_SECTION = 'Endorsements';

export enum ENDORSEMENT_REFERENCE_CATEGORIES {
  FINANCIAL = 'Financial',
  NON_FINANCIAL = 'Non Financial',
}
